import React from 'react';

const Logo = () => (
	<img src={app.runtime.logo} style={app.runtime.logoSize} alt={app.runtime.name}/>
);

export default Logo;
